import { Injectable } from '@angular/core';
import { Inject } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { ConfigService} from './config.service';
import { catchError, map } from 'rxjs/operators';
import {BasicResponse} from '@auth-suite-services/services';
import { RemoteDeviceGidListInterface, RemoteDeviceInterface, RemoteDeviceInterfaceAPI, ServicePointSetupAPI } from '../..';
import { linkedGidListInterface, linkedGidListInterfaceAPI, unlinkedGidListInterface } from '../model/remote-device';

@Injectable({
  providedIn: 'root'
})
export class RemoteDeviceService {

  private URL;
  headers: HttpHeaders;

  constructor(@Inject(ConfigService) private config: any, private httpClient: HttpClient) {
    this.URL = config.REST_SERVER_HOST + '/api/amassapp'
    this.headers = new HttpHeaders().set('DoNotIntercept', 'true');
  }

  getAllRemoteDevice(pageIndex: number, pageSize: number, sortActive: string, sort: string, globalId: number, serialNo: string): Observable<RemoteDeviceInterfaceAPI> {
    console.log('PageIndex; PageSize; SortActive; Sort');
    console.log(pageIndex, pageSize, sortActive, sort);
    const headers = this.headers;
    const filters = {
      globalId,
      serialNo,
    };
    console.log('filters:');
    console.log(filters);
    // tslint:disable-next-line:max-line-length
    return this.httpClient.post<RemoteDeviceInterfaceAPI>(`${this.URL}/rde/getallremotedevice/${pageIndex}/${pageSize}/${sortActive ? sortActive : 'id'}/${sort ? sort : 'asc'}/${globalId ? globalId : 0}/${serialNo ? serialNo : 0}`, filters, {headers}).pipe(catchError(this.handleError));
  }

  getAllRemoteDeviceGidList(pageIndex: number, pageSize: number, sortActive: string, sort: string, refRDEID: number): Observable<linkedGidListInterfaceAPI> {
    const headers = this.headers;
    const filters = {
      refRDEID,
    };
    // tslint:disable-next-line:max-line-length
    return this.httpClient.post<linkedGidListInterfaceAPI>(`${this.URL}/rde/getallremotedevicegidlist/${pageIndex}/${pageSize}/${sortActive ? sortActive : 'id'}/${sort ? sort : 'asc'}`, filters, {headers}).pipe(catchError(this.handleError));
  }

  unlinkRemoteDeviceGidList(rdg: any): Observable<BasicResponse> {
    const headers = this.headers;
    console.log('Update rdg: ' + JSON.stringify(rdg));
    // tslint:disable-next-line:max-line-length
    return this.httpClient.post<BasicResponse>(`${this.URL}/rde/unlinkremotedevicegidlist`, rdg, {headers}).pipe(catchError(this.handleError));
  }


  getRemoteDeviceGidList( id: number): Observable<linkedGidListInterfaceAPI> {
    const headers = this.headers;
    // tslint:disable-next-line:max-line-length
    return this.httpClient.post<linkedGidListInterfaceAPI>(`${this.URL}/rde/getallremotedevicegidlist/${id ? id : 0}`, {headers}).pipe(catchError(this.handleError));
  }

  getRemoteDevice(id: number): Observable<RemoteDeviceInterface> {
    console.log('PageIndex; PageSize; SortActive; Sort');
    console.log(id);
    const headers = this.headers;
    // tslint:disable-next-line:max-line-length
    return this.httpClient.post<RemoteDeviceInterface>(`${this.URL}/rde/getremotedevice/${id}`, {}, {headers}).pipe(catchError(this.handleError));
  }

  updateRDE(rde: RemoteDeviceInterface): Observable<BasicResponse> {
    const headers = this.headers;
    console.log('Update rde: ' + JSON.stringify(rde));
    return this.httpClient.post<BasicResponse>(`${this.URL}/rde/updateremotedevice`, rde, {headers}).pipe(catchError(this.handleError));
  }

  createRDE(rde: RemoteDeviceInterface): Observable<BasicResponse> {
    const headers = this.headers;
    console.log('Update tok: ' + JSON.stringify(rde));
    return this.httpClient.post<BasicResponse>(`${this.URL}/rde/createremotedevice`, rde, {headers}).pipe(catchError(this.handleError));
  }

  createRDG(rde: RemoteDeviceGidListInterface): Observable<BasicResponse> {
    const headers = this.headers;
    console.log('create rdelist: ' + JSON.stringify(rde));
    return this.httpClient.post<BasicResponse>(`${this.URL}/rde/createremotedevicegidlist`, rde, {headers}).pipe(catchError(this.handleError));
  }

  // Added service for GIDLIST                  07/14/2023 AK
  // getAllSPS(): Observable<RemoteDeviceInterfaceAPI> {
  //   const headers = this.headers;
  //   return this.httpClient.get<RemoteDeviceInterfaceAPI>(`${this.URL}/sps/spslist`,
  //       {headers});
  // }

  // See C001 - 2026-07-27 - JB
  // getAllSPS(): Observable<ServicePointSetupAPI> {
  //   const headers = this.headers;
  //   return this.httpClient.get<ServicePointSetupAPI>(`${this.URL}/rde/getallsps`, {headers}).pipe(
  //       catchError(this.handleError));
  // }
  getAllSPS(
    globalId: string = '',
    servicePointName: string = ''
  ): Observable<ServicePointSetupAPI> {
    const headers = this.headers;
    let params = new HttpParams();
    if (globalId) {
      params = params.set('globalId', globalId);
    }
    if (servicePointName) {
      params = params.set('servicePointName', servicePointName);
    }
    return this.httpClient.get<ServicePointSetupAPI>(`${this.URL}/rde/getallsps`, {
      headers,
      params,
    }).pipe(
        catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
          `Backend returned code ${error.status}, ` + `body was: ${error.error}`
      );
    }
    // return an observable with a user-facing error message
    // return throwError('Something bad happened; please try again later.');
    return throwError(error);
  }
}

// ========================================
// CHANGE LOG
// ========================================
// C001: Updated getAllSPS() in suredebit-setup RemoteDeviceService to accept optional globalId and servicePointName query filters and pass them as HttpParams on GET /rde/getallsps. Previous behavior: getAllSPS() always requested the full unfiltered SPS list with no query parameters. New behavior: Optional globalId and/or servicePointName are sent as query params when non-empty; empty defaults preserve the unfiltered call for backward compatibility. Reason: Ticket #15290 / #8585 — keep suredebit-setup copy aligned with libs/services so both service copies support server-side GID/name search. Context: Mirror change in libs/services remote-device.service.ts for portaladmin-ss Remote Device GID search. Impact: Callers of this library copy can filter SPS; no-arg callers unchanged. - 2026-07-27 - JB

